import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs"; 
import { UserProfession, UserProfessionClient } from "../../../../web-api-client";
import { WorkTypes } from "../../../../shared/enum/workTypes.enum";

@Component({
  selector: 'app-userProfession-creation',
  templateUrl: './userProfession-creation.component.html',
  styleUrls: ['./userProfession-creation.component.scss']
})
export class UserProfessionCreationComponent implements OnInit  {

  public isLoaded = true;

   Form: FormGroup;

  public workType = WorkTypes;
  public workTypes = Object.keys(WorkTypes).filter(
    key => !isNaN(Number(WorkTypes[key]))
  );

  public onClose = new Subject<boolean>();

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, public client: UserProfessionClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: ['', Validators.required],
      wTypes: [WorkTypes.All, Validators.required],
      isActive: [null, Validators.required]
    });
  }
  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service = new UserProfession();

      service.idUserProfession = 0;
      service.title = this.Form.value.title;
      service.workType = this.Form.value.wTypes;
      service.isActive = this.Form.value.isActive;

      this.client.create(service).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
